const refs = 'carts'
export default [
    {
        path: '/'+refs, 
        name: refs,
        component: () => import('@/views/'+refs+'/Show.vue')
    },
];